import { Providers } from './providers';

export const App = () => <Providers />;
